var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ReReassignExtCalls"},[_c('base-button',{staticClass:"tmplt-btn",attrs:{"type":"primary","simple":""},on:{"click":function($event){return _vm.signUpStaff()}}},[_vm._v("Подписать сотрудника на телефонии")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }